<template>
  <div class="game-head">
    <div class="main">
      <div class="one info">
        <router-link :to="{name: 'FGContest', params:{key:preview.contest.key}}">
          <h3 class="subtitle">{{preview.contest.name}}</h3>
        </router-link>
        <router-link :to="{ name: 'FGGame', params: {'gameKey': preview.game.key}}"><h2 class="title with-subtitle-top">{{preview.game.name}}</h2></router-link>
        <p v-if="preview.game.desc">{{preview.game.desc}}</p>
        <div class="links">
          <button
            class="clean small link"
            @click="showPreview='rule'">Rule</button>
          <button
            class="clean small link"
            @click="showPreview='rewards'">Rewards</button>
          <button
            class="clean small link"
            @click="showPreview='pointsystem'">Pointsystem</button>
        </div>
      </div>
      <div class="two">
        <div class="sport-icon">
            <img v-if="preview.contest.sport.isCricket" src="@/assets/imgs/batsman-ready.png" />
            <img v-else-if="preview.contest.sport.isFootball" src="@/assets/imgs/sport-football.svg" />
        </div>
      </div>
    </div>
    <div v-if="showPreview" class="previews card inv">
      <button
            class="clean small"
            @click="showPreview=''">Hide</button>
      <RulePreview
        v-if="showPreview === 'rule'"
        :contestKey="preview.contest.key"></RulePreview>
      <RewardsPreview
        v-if="showPreview === 'rewards'"
        :contestKey="preview.contest.key"></RewardsPreview>
      <PointsystemPreview
        v-if="showPreview === 'pointsystem'"
        :contestKey="preview.contest.key"></PointsystemPreview>
    </div>
  </div>
</template>
<script>
import RulePreview from '@/components/fantasygame/RulePreview'
import RewardsPreview from '@/components/fantasygame/RewardsPreview'
import PointsystemPreview from '@/components/fantasygame/PointsystemPreview'

export default {
  components: {
    RulePreview,
    RewardsPreview,
    PointsystemPreview
  },

  props: {
    preview: Object
  },

  data () {
    return {
      showPreview: ''
    }
  }
}
</script>